/* eslint-disable */

import XLSX from 'xlsx'
import moment from 'moment'
import CryptoJS from 'crypto-js'
import md5 from 'crypto-js/md5'
import format from 'crypto-js/format-hex'
import BigNumber from "bignumber.js";
import {
  Notify
} from 'vant'
import * as dd from 'dingtalk-jsapi'
import { platformConfig } from '../assets/config'

export const uuid = () => { // 生产uuid
  let s = []
  let hexDigits = '0123456789abcdef'
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
  }
  s[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = '-'
  let uuid = s.join('')
  return uuid
}
/**
 *
 * @param number 要保留8位小数的数字
 * @returns
 */
 export const cutOutNumber = (number) => {
  let x = new BigNumber(number)
  return Number(x.toFixed(8)).toString()
}

// 获取本月最后一天
export const getThisMonth = (data) => {
  let day = moment(data).format('YYYYMMDD')
  let nowYear = moment(data).format('YYYY')
  let nowMonth = moment(data).format('MM')
  var monthEndDate = new Date(Number(nowYear), Number(nowMonth), 0)
  return monthEndDate.getDate()
}
export const getInvoiceType = (item) => {
    let type = ''
    switch (item) {
      case '01':
        return type = '专票'
      case '04':
        return type = '普票'
      case '10':
        return type = '电普'
      case '08':
        return type = '电专'
      case '09':
        return type = '数电专'
      case '90':
        return type = '数电普'
      case '11':
        return type = '卷票'
      case '14':
        return type = '通行费'
      case '201':
        return type = '火车'
      case '202':
        return type = '飞机'
      case '207':
        return type = '出租'
      case '200':
        return type = '定额'
      case '85':
        return type = '数电纸专'
      case '86':
        return type = '数电纸普'
      case '51':
        return type = '数电火车'
      case '61':
        return type = '数电飞机'
      default:
        return type = '发票'
    }
    return type
}
export const getInvoiceColor = (item) => {
  let color = ''
  switch (item) {
    case '01':
      return color = 'Tel'
    case '04':
      return color = 'Common'
    case '10':
      return color = 'Common'
    case '09':
      return color = 'Tel'
    case '08':
      return color = 'Tel'
    case '11':
      return color = 'Fixed'
    case '201':
      return color = 'Plane'
    case '202':
      return color = 'Plane'
    case '207':
      return color = 'Plane'
    case '200':
      return color = 'Fixed'
    case '85':
      return color = 'FullInvoicePaper'
    case '86':
      return color = 'FullInvoicePaper'
    case '51':
      return color = 'FullInvoicePaper'
    case '61':
      return color = 'FullInvoicePaper'
    default:
      return color = 'Common'
  }
  return color
}

/**
 * @deprecated 去除空格
 * @param value
 * @returns
 */
 export const removeSpace = (value) => {
  if (typeof value === 'string') {
    return value.trim()
  }
  return value
}

/**
 * @description 自动判断是否拼接购方信息
 * @param info
 * @returns
 */
 export const autoMontageLookUp = (info, invoiceType = null) => {
  const config = info ? deepCopy(info) : {}
  config.bankNo = config.bankNo || config.bankCardNum
  if (!isAllElectric(invoiceType)) { // 不是数电
    config.address = [config.address, config.tel].filter(item => Boolean(item)).join(' ')
    config.bankName = [config.bankName, config.bankNo].filter(item => Boolean(item)).join(' ')
    config.tel = ''
    config.bankCardNum = ''
    config.bankNo = ''
  } else {
    config.bankNo = config.bankNo || config.bankCardNum
    config.bankCardNum = config.bankNo || config.bankCardNum
  }
  return config
}

/**
 * @description 剪切开票备注
 */
export const cutInvoiceRemark = (invoiceType, remark) => {
  let str = remark || ''
  if (isAllElectric(invoiceType)) {
    str = str.substring(0, 200)
  } else {
    str = subMixStr(str, 184)
  }
  return str
}

/**
 * @description 备注行数校验
 */
 export const remarkLineNumTest = (remark, invoiceType = 7) => {
  const line = isAllElectric(invoiceType) ? 6 : 5
  if (remark.split('\n').length > line) {
    Notify({ type: 'danger', message: '税控备注最大不能超过5行，数电为6行' })
    return false
  }
  return true
}

/**
 * @description 校验商品名称长度
 */
export const goodNameLengthTest = (name, invoiceType = 7, index) => {
  const sizeText = isAllElectric(invoiceType) ? '50个汉字或100个字符' : '36个汉字或72个字符'
  const msg = (index || index === 0) ? `第${index + 1}行, 货物及服务名称不能大于${sizeText}` : `货物及服务名称不能大于${sizeText}`;
  const size = isAllElectric(invoiceType) ? 100 : 72
  if (getMixLength(name) > size) {
    Notify({ type: 'danger', message: msg })
    return false
  }
  return true
}

/**
 * @description 校验商品
 * @param { Array } list
 * @param { Number } invoiceType
 */
 export const testGoods = ({ list = [], invoiceType = 7, required = true }) => {
  const arr = list && Array.isArray(list) ? list : []
  let flag = true
  if (required && !arr.length) {
    Notify({ type: 'danger', message: '请选择商品' })
    return false
  }
  for (let index = 0; index < arr.length; index++) {
    const element = arr[index]
    try {
      if (!goodNameLengthTest(element.goodsName, invoiceType, index)) {
        throw new Error('')
      }
      if (element.specification && getMixLength(element.specification) > 40) {
        throw new Error(`第${index + 1}行，规格型号长度错误，不能超过40个字符`)
      }
      if (element.unit && getMixLength(element.unit) > 22) {
        throw new Error(`第${index + 1}行，单位长度错误，不能超过22个字符`)
      }
    } catch (error) {
      if (error.message) {
        Notify({ type: 'danger', message: error.message })
      }
      flag = false
      break
    }
  }
  return flag
}

export const testTaxNo = (value, invoiceType) => {
  if (isSpecialTicket(invoiceType)) { // 专票
    if (
    !/^[0-9A-Za-z]{9}$/.test(value) &&
    !/^[0-9A-Za-z]{15}$/.test(value) &&
    !/^[0-9A-Za-z]{17}$/.test(value) &&
    !/^[0-9A-Za-z]{18}$/.test(value) &&
    !/^[0-9A-Za-z]{19}$/.test(value) &&
    !/^[0-9A-Za-z]{20}$/.test(value)) {
      Notify({ type: 'danger', message: '购方税号输入有误,仅支持长度9、15、17、18、19、20!' })
      return false
    }
  }
  if (!isEmpty(value) && (!/^[a-zA-Z0-9]+$/.test(value.trim()) || getMixLength(value.trim()) > 20)) {
    Notify({ type: 'danger', message: '税号格式错误仅支持数字/字母，长度不能超过20字符!' })
    return false
  }
  return true
}

/**
 * @description 校验对应主体信息
 */
 export class CheckBusinessMainInfo {
  constructor ({ invoiceType }) {
    this.invoiceType = invoiceType
    this.msgMap = isAllElectric(invoiceType) || !invoiceType ?
      {
        purchaserAddress: { msg: '购方地址', maxLength: 100 },
        purchaserBankName: { msg: '购方银行', maxLength: 100 },
        purchaserBankAccount: { msg: '购方银行账号', maxLength: 100 },
        purchaserTel: { msg: '购方电话', maxLength: 100 },
        purchaserPhone: { msg: '手机号', maxLength: 100 },
        remark: { msg: '备注', maxLength: 200, isTestLen: true },
      }
    :
      {
        purchaserAddress: { msg: '购方地址、电话', maxLength: 100 },
        purchaserBankName: { msg: '开户行银行、账号', maxLength: 100 },
        purchaserPhone: { msg: '手机号', maxLength: 100 },
        remark: { msg: '备注', maxLength: 184 },
      }
  }
  purchaserName ({ value = '', required = true, msg = '购方名称' }) {
    if (required && (isEmpty(value) || isEmpty(value.trim()))) {
      throw new Error(`${msg}不能为空!`)
    }
    if (getMixLength(value) > 100) {
      throw new Error(`${msg}不允许超过100字符!`)
    }
  }
  purchaserTaxNo ({ value = '', required = true }) {
    const isRequired = this.invoiceType ? (required && !isUniversalTicket(this.invoiceType) && (isEmpty(value) || isEmpty(value.trim()))) : (required && (isEmpty(value) || isEmpty(value.trim())))
    if (isRequired) {
      throw new Error("购方税号不能为空!")
    }
    if (!testTaxNo(value, this.invoiceType)) {
      throw new Error("")
    }
  }
  purchaserAddress ({ value = '', required = true }) {
    const isRequired = this.invoiceType ? (required && !!(isSpecialTicket(this.invoiceType) && !isAllElectric(this.invoiceType)) && (isEmpty(value) || isEmpty(value.trim()))) : (required && (isEmpty(value) || isEmpty(value.trim())))
    if (isRequired) {
      throw new Error(`${this.msgMap['purchaserAddress'].msg}不能为空!`)
    }

    if (!isEmpty(value) && getMixLength(value) > this.msgMap['purchaserAddress'].maxLength) {
      throw new Error(`${this.msgMap['purchaserAddress'].msg}不允许超过${this.msgMap['purchaserAddress'].maxLength}字符!`)
    }
  }
  purchaserTel ({ value = '', required = true }) {
    if (required && (isEmpty(value) || isEmpty(value.trim()))) {
      throw new Error(`${this.msgMap['purchaserTel'].msg}不能为空!`)
    }

    if (!isEmpty(value) && getMixLength(value) > this.msgMap['purchaserTel'].maxLength) {
      throw new Error(`${this.msgMap['purchaserTel'].msg}不允许超过${this.msgMap['purchaserTel'].maxLength}字符!`)
    }
  }
  purchaserBankName ({ value = '', required = true }) {
    const isRequired = this.invoiceType ? (required && !!(isSpecialTicket(this.invoiceType) && !isAllElectric(this.invoiceType)) && (isEmpty(value) || isEmpty(value.trim()))) : (required && (isEmpty(value) || isEmpty(value.trim())))
    if (isRequired) {
      throw new Error(`${this.msgMap['purchaserBankName'].msg}不能为空!`)
    }

    if (!isEmpty(value) && getMixLength(value.trim()) > this.msgMap['purchaserBankName'].maxLength) {
      throw new Error(`${this.msgMap['purchaserBankName'].msg}不允许超过${this.msgMap['purchaserBankName'].maxLength}字符!`)
    }
  }
  purchaserBankAccount ({ value = '', required = true }) {
    if (required && (isEmpty(value) || isEmpty(value.trim()))) {
      throw new Error(`${this.msgMap['purchaserBankAccount'].msg}不能为空!`)
    }

    if (!isEmpty(value) && getMixLength(value.trim()) > this.msgMap['purchaserBankAccount'].maxLength) {
      throw new Error(`${this.msgMap['purchaserBankAccount'].msg}不允许超过${this.msgMap['purchaserBankAccount'].maxLength}字符!`)
    }
  }
  purchaserPhone ({ value = '', required = true }) {
    if (required && (isEmpty(value) || isEmpty(value.trim()))) {
      throw new Error(`${this.msgMap['purchaserPhone'].msg}不能为空!`)
    }
    console.log(value, '111')
    if (!isEmpty(value) && !/0?(13|14|15|18|17|16|19)[0-9]{9}/.test(value)) {
      throw new Error(`${this.msgMap['purchaserPhone'].msg}格式不正确!`)
    }
  }
  remark ({ value = '', required = false }) {
    if (required && (isEmpty(value) || isEmpty(value.trim()))) {
      throw new Error(`${this.msgMap['remark'].msg}不能为空!`)
    }
    if (!remarkLineNumTest(value, this.invoiceType || 5)) {
      throw new Error("")
    }
    if (this.msgMap['remark'].isTestLen) {
      if (!isEmpty(value) && value.trim().length > this.msgMap['remark'].maxLength) {
        throw new Error(`${this.msgMap['remark'].msg}不允许超过${this.msgMap['remark'].maxLength}字!`)
      }
    } else {
      if (!isEmpty(value) && getMixLength(value.trim()) > this.msgMap['remark'].maxLength) {
        throw new Error(`${this.msgMap['remark'].msg}不允许超过${this.msgMap['remark'].maxLength}字符!`)
      }
    }
  }
  unitPriceWithTax (v) {
    if (!v) return
    const maxNum = v.toString().indexOf('.') !== -1 ? 16 : 15
    if (v && v.toString().length > maxNum) {
      throw new Error("数电含税单价小数点前后合计位数不能超过15位")
    }
  }
  unitPrice (v) {
    if (!v) return
    const maxNum = v.toString().indexOf('.') !== -1 ? 16 : 15
    if (v && v.toString().length > maxNum) {
      throw new Error("数电不含税单价小数点前后合计位数不能超过15位")
    }
  }
  quantity (v) {
    if (!v) return
    const maxNum = v.toString().indexOf('.') !== -1 ? 16 : 15
    if (v && v.toString().length > maxNum) {
      throw new Error("数电数量小数点前后合计位数不能超过15位")
    }
  }
}

export const cookie = { // 关于cookie的相关设置
  set: function (name, value, days) {
    let exp = new Date()
    exp.setTime(exp.getTime() + days * 24 * 60 * 60 * 1000)
    document.cookie = name + '=' + escape(value) + ';expires=' + exp.toGMTString() + ';path=/'
  },
  get: function (name) {
    var arr
    var reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
    arr = document.cookie.match(reg)
    if (arr) {
      return unescape(arr[2])
    } else {
      return null
    }
  },
  delete: function (name) {
    var exp = new Date()
    exp.setTime(exp.getTime() - 1)
    var cval = this.get(name)
    if (cval !== null) {
      document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString()
    }
  }
}

export const getQuery = () => {
  let url = window.location.search
  let theRequest = {}
  if (url.indexOf('?') !== -1) {
    let str = url.substr(1)
    var strs = str.split('&')
    for (let i = 0; i < strs.length; i++) {
      theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1])
    }
  }
  return theRequest
}


export const formatDate = (fmt, date) => { // 时间格式化
  date = new Date(date)
  let o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    'S': date.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  for (let k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
  }
  return fmt
}

export const sessionStorage = {
  set: function (name, val) {
    if (val instanceof Object) {
      val = JSON.stringify(val)
    }
    window.sessionStorage.setItem(name, val)
  },

  get: function (key) {
    let val = window.sessionStorage.getItem(key)
    if (val) {
      return val
    } else {
      return null
    }
  },

  delete: function (key) {
    window.sessionStorage.removeItem(key)
  },

  clear: function () {
    window.sessionStorage.clear()
  }
}

export const localStorage = {
  set: function (key, val) {
    if (val instanceof Object) {
      val = JSON.stringify(val)
    }
    window.localStorage.setItem(key, val)
  },
  get: function (key) {
    let val = window.localStorage.getItem(key)
    if (val) {
      return val
    } else {
      return null
    }
  },
  delete: function (key) {
    window.localStorage.removeItem(key)
  },
  clear: function () {
    window.localStorage.clear()
  }
}

export const countProperties = (o) => {
  let count = 0
  for (let property in o) {
    if (Object.prototype.hasOwnProperty.call(o, property)) {
      count++
    }
  }
  return count
}

export function find(list, f) {
  return list.filter(f)[0]
}

export const deepCopy = (obj, cache) => {
  if (cache === void 0) cache = []

  if (obj === null || typeof obj !== 'object') {
    return obj
  }

  var hit = find(cache, function (c) {
    return c.original === obj
  })
  if (hit) {
    return hit.copy
  }

  var copy = Array.isArray(obj) ? [] : {}
  cache.push({
    original: obj,
    copy: copy
  })

  Object.keys(obj).forEach(function (key) {
    copy[key] = deepCopy(obj[key], cache)
  })

  return copy
}

export const isArr = (obj) => {
  return obj.__proto__ === Array.prototype
}

export const scrollTo = (y) => {
  window.scrollTo({
    top: y,
    behavior: 'smooth'
  })
}

export const memoize = (fn) => {
  let cache = {}
  return function () {
    let key = JSON.stringify(arguments)
    let value = cache[key]
    if (!value) {
      value = [fn.apply(this, arguments)]
      cache[key] = value
    }
    return value[0]
  }
}

/* options的默认值
 *  options.leading = true; 表示首次调用返回值方法时，会马上调用func；否则仅会记录当前时刻，当第二次调用的时间间隔超过wait时，才调用func。
 *
 *  options.trailing = true;
 *  表示当调用方法时，未到达wait指定的时间间隔，则启动计时器延迟调用func函数，若后续在既未达到wait指定的时间间隔和func函数又未被调用的情况下调用返回值方法，则被调用请求将被丢弃。
 */
export const throttle = (func, wait, options) => {
  let context = undefined
  let args = undefined
  let result = undefined
  var timeout = null
  var previous = 0
  if (!options) {
    options = {}
  }

  const later = function () {
    previous = options.leading === false ? 0 : Date.parse(new Date())
    timeout = null
    result = func.apply(context, args)
    if (!timeout) {
      context = args = null
    }
  }

  return function () {
    let now = Date.parse(new Date())

    if (!previous && options.leading === false) {
      previous = now
    }

    // 计算剩余时间
    let remaining = wait - (now - previous)
    context = this
    args = arguments

    // 当到达wait指定的时间间隔，则调用func函数
    if (remaining <= 0 || remaining > wait) {
      // 由于setTimeout存在最小时间精度问题，因此会存在到达wait的时间间隔，但之前设置的setTimeout操作还没被执行，因此为保险起见，这里先清理setTimeout操作
      if (timeout) {
        clearTimeout(timeout)
        timeout = null
      }
      previous = now
      result = func.apply(context, args)

      if (!timeout) {
        context = args = null
      }

    } else if (!timeout && options.trailing !== false) {
      // options.trailing=true时，延时执行func函数
      timeout = setTimeout(later, remaining)
    }
    return result
  }
}

export const debounce = (func, wait, immediate) => {
  // immediate默认为false
  let timeout = null
  let args = undefined
  let context = undefined
  let timestamp = undefined
  let result = undefined

  const later = function () {
    // 当wait指定的时间间隔期间多次调用_.debounce返回的函数，则会不断更新timestamp的值，导致last < wait && last >= 0一直为true，从而不断启动新的计时器延时执行func
    let last = Date.parse(new Date()) - timestamp

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null

      if (!immediate) {
        result = func.apply(context, args)

        if (!timeout) {
          context = args = null
        }
      }
    }
  }

  return function () {
    context = this
    args = arguments
    timestamp = Date.parse(new Date())

    // 第一次调用该方法时，且immediate为true，则调用func函数
    var callNow = immediate && !timeout

    // 在wait指定的时间间隔内首次调用该方法，则启动计时器定时调用func函数
    if (!timeout) {
      timeout = setTimeout(later, wait)
    }

    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}
export const compressFile = (file,callback) => {
  console.log(file)
  if (!file.type.includes('image/')) {
    console.log(file)
    callback(file)
    return
  }
  let fileObj = file
  let reader = new FileReader()
  reader.readAsDataURL(fileObj) //转base64
  reader.onload = function(e) {
      let image = new Image() //新建一个img标签（还没嵌入DOM节点)
      image.src = e.target.result
      image.onload = function () {
          let canvas = document.createElement('canvas'), // 新建canvas
          context = canvas.getContext('2d'),
          imageWidth = image.width,    //压缩后图片高度和宽度
                  imageHeight = image.height,
                  data ='';
          canvas.width = imageWidth
          canvas.height = imageHeight
          context.drawImage(image, 0, 0, imageWidth, imageHeight)
          if (file.size && file.size > 500000) {
            data = canvas.toDataURL('image/jpeg',0.1) // 0.1压缩至以前的0.1倍
          } else {
            data = canvas.toDataURL('image/jpeg',0.8) // 0.8压缩至以前的0.8倍
          }
          let arr = data.split(','), mime = arr[0].match(/:(.*?);/)[1], // 转成blob
                  bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
          while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
          }
          let files = new window.File([new Blob([u8arr], {type: mime})], 'test.jpeg', {type: 'image/jpeg'}) // 转成file
          callback(files) // 回调
      }
      image.onerror = function (err) {
        console.error('图片加载失败（最常见原因：格式不支持 / 跨域）', err);
        // 失败时直接返回原文件
        callback(file);
      };
    }
}

export const convertBase64UrlToBlob = (urlData) => {
  let arr = urlData.split(','), mime = arr[0].match(/:(.*?);/)[1]
  let bstr = atob(arr[1])
  let n = bstr.length
  let u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new Blob([u8arr], { type: mime })
}

export const dataURLtoFile = (dataurl, filename) => {
  var arr = dataurl.dataURL.split(','), mime = arr[0].match(/:(.*?);/)[1],
  bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n)
  while(n--){
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], filename, {type:mime})
}

export const isMobile = () => {
  return (/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i).test(window.navigator.userAgent)
}
export const toMoney = (num, n) => {
  if (num) {
    n = n > 0 && n <= 20 ? n : 2
    num = parseFloat((num + '').replace(/[^\d\.-]/g, '')).toFixed(n) + ''
    var l = num.split('.')[0].split('').reverse(), r = num.split('.')[1]
    let t = ''
    for (let i = 0; i < l.length; i++) {
      t += l[i] + ((i + 1) % 3 === 0 && (i + 1) !== l.length ? ',' : '')
    }
    return t.split('').reverse().join('') + '.' + r
  } else {
    return 0
  }
}
/*金额小写转大写*/
export const digitUppercase = (currencyDigits = 0) => {
  // Constants:
  var MAXIMUM_NUMBER = 999999999999999999999.99;
  // Predefine the radix characters and currency symbols for output:
  var CN_ZERO = "零";
  var CN_ONE = "壹";
  var CN_TWO = "贰";
  var CN_THREE = "叁";
  var CN_FOUR = "肆";
  var CN_FIVE = "伍";
  var CN_SIX = "陆";
  var CN_SEVEN = "柒";
  var CN_EIGHT = "捌";
  var CN_NINE = "玖";
  var CN_TEN = "拾";
  var CN_HUNDRED = "佰";
  var CN_THOUSAND = "仟";
  var CN_TEN_THOUSAND = "万";
  var CN_HUNDRED_MILLION = "亿";
  var CN_SYMBOL = "";
  var CN_DOLLAR = "元";
  var CN_TEN_CENT = "角";
  var CN_CENT = "分";
  var CN_INTEGER = "整";
  let full;
  // Variables:
  var integral;    // Represent integral part of digit number.
  var decimal;    // Represent decimal part of digit number.
  var outputCharacters;    // The output result.
  var parts;
  var digits, radices, bigRadices, decimals;
  var zeroCount;
  var i, p, d, ds;
  var quotient, modulus;
  if (/^\d+.00$/.test(`${currencyDigits}`)) {
    full = true
  }
  // Validate input string:
  currencyDigits = currencyDigits.toString();
  if (currencyDigits == "") {
    console.log("不能为空 请输入数字金额!如：123.23");
    return "";
  }
  if (currencyDigits.match(/[^,.\d]/) != null) {
    console.log("输入字符串中的字符无效!");
    return "";
  }
  if ((currencyDigits).match(/^((\d{1,3}(,\d{3})*(.((\d{3},)*\d{1,3}))?)|(\d+(.\d+)?))$/) == null) {
    console.log("请输入正确的数字金额!");
    return "";
  }

  // Normalize the format of input digits:
  currencyDigits = currencyDigits.replace(/,/g, "");    // Remove comma delimiters.
  currencyDigits = currencyDigits.replace(/^0+/, "");    // Trim zeros at the beginning.
  // Assert the number is not greater than the maximum number.
  if (Number(currencyDigits) > MAXIMUM_NUMBER) {
    console.log("Too large a number to convert!");
    return "";
  }

  // Process the coversion from currency digits to characters:
  // Separate integral and decimal parts before processing coversion:
  parts = currencyDigits.split(".");
  if (parts.length > 1) {
    integral = parts[0];
    decimal = parts[1];
    // Cut down redundant decimal digits that are after the second.
    decimal = decimal.substr(0, 2);
  }
  else {
    integral = parts[0];
    decimal = "";
  }
  // Prepare the characters corresponding to the digits:
  digits = new Array(CN_ZERO, CN_ONE, CN_TWO, CN_THREE, CN_FOUR, CN_FIVE, CN_SIX, CN_SEVEN, CN_EIGHT, CN_NINE);
  radices = new Array("", CN_TEN, CN_HUNDRED, CN_THOUSAND);
  bigRadices = new Array("", CN_TEN_THOUSAND, CN_HUNDRED_MILLION);
  decimals = new Array(CN_TEN_CENT, CN_CENT);
  // Start processing:
  outputCharacters = "";
  // Process integral part if it is larger than 0:
  if (Number(integral) > 0) {
    zeroCount = 0;
    for (i = 0; i < integral.length; i++) {
      p = integral.length - i - 1;
      d = integral.substr(i, 1);
      quotient = p / 4;
      modulus = p % 4;
      if (d == "0") {
        zeroCount++;
      }
      else {
        if (zeroCount > 0) {
          outputCharacters += digits[0];
        }
        zeroCount = 0;
        outputCharacters += digits[Number(d)] + radices[modulus];
      }
      if (modulus == 0 && zeroCount < 4) {
        outputCharacters += bigRadices[quotient];
      }
    }
    outputCharacters += CN_DOLLAR;
  }
  // Process decimal part if there is:
  if (decimal != "") {
    for (i = 0; i < decimal.length; i++) {
      d = decimal.substr(i, 1);
      ds = decimal.substr(-1, 1);
      if (d == 0) {
        if (ds == 0) {
          outputCharacters += "";
        }
        else {
          outputCharacters += digits[Number(d)];
        }
      }
      else {

        outputCharacters += digits[Number(d)] + decimals[i];

      }
    }
  }
  // Confirm and return the final output string:
  if (outputCharacters == "") {
    outputCharacters = CN_ZERO + CN_DOLLAR;
  }
  if (decimal == "" || full) {
    outputCharacters += CN_INTEGER;
  }
  outputCharacters = CN_SYMBOL + outputCharacters;
  return outputCharacters;
}


export const onCount = {
  /*
    说明：javascript的加法结果会有误差，在两个浮点数相加的时候会比较明显。这个函数返回较为精确的加法结果。
    调用：add(arg1,arg2)
    返回值：arg1加上arg2的精确结果
  */
  add: function (arg1, arg2) {
    return new BigNumber(arg1).plus(new BigNumber(arg2)).toNumber() || 0
    // var r1, r2, m
    // try {
    //   r1 = (arg1 || 0).toString().split('.')[1].length
    // } catch (e) {
    //   r1 = 0
    // }
    // try {
    //   r2 = (arg2 || 0).toString().split('.')[1].length
    // } catch (e) {
    //   r2 = 0
    // }
    // m = Math.pow(10, Math.max(r1, r2))
    // return (arg1 * m + arg2 * m) / m
  },
  /*
    说明：javascript的减法结果会有误差，在两个浮点数相减的时候会比较明显。这个函数返回较为精确的减法结果。
    调用：sub(arg1,arg2)
    返回值：arg1减去arg2的精确结果
  */
  sub: function (arg1, arg2) {
    return new BigNumber(arg1).minus(new BigNumber(arg2)).toNumber() || 0
    // var r1, r2, m, n
    // try {
    //   r1 = (arg1 || 0).toString().split('.')[1].length
    // } catch (e) {
    //   r1 = 0
    // }
    // try {
    //   r2 = (arg2 || 0).toString().split('.')[1].length
    // } catch (e) {
    //   r2 = 0
    // }
    // m = Math.pow(10, Math.max(r1, r2))
    // //last modify by deeka
    // //动态控制精度长度
    // n = (r1 >= r2) ? r1 : r2
    // return ((arg1 * m - arg2 * m) / m).toFixed(n)
  },
  /*
    说明：javascript的乘法结果会有误差，在两个浮点数相乘的时候会比较明显。这个函数返回较为精确的乘法结果。
    调用：mul(arg1,arg2)
    返回值：arg1乘以arg2的精确结果
  */
  mul: function (arg1, arg2) {
    return new BigNumber(arg1).times(new BigNumber(arg2)).toNumber() || 0
    // var m = 0, s1 = (arg1 || 0).toString(), s2 = (arg2 || 0).toString()
    // try {
    //   m += s1.split('.')[1].length
    // } catch (e) {
    // }
    // try {
    //   m += s2.split('.')[1].length
    // } catch (e) {
    // }
    // return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m)

  },
  /*
    说明：javascript的除法结果会有误差，在两个浮点数相除的时候会比较明显。这个函数返回较为精确的除法结果。
    调用：div(arg1,arg2)
    返回值：arg1除以arg2的精确结果
  */
  div: function (arg1, arg2) {
    return new BigNumber(arg1).dividedBy(new BigNumber(arg2)).toNumber() || 0
    // var t1 = 0, t2 = 0, r1, r2
    // try {
    //   t1 = (arg1 || 0).toString().split('.')[1].length
    // } catch (e) {
    // }
    // try {
    //   t2 = (arg2 || 0).toString().split('.')[1].length
    // } catch (e) {
    // }
    // r1 = Number((arg1 || 0).toString().replace('.', ''))
    // r2 = Number((arg2 || 0).toString().replace('.', ''))
    // if (Number(arg1) === 0 && Number(arg2) === 0) {
    //   return 0
    // }
    // return (r1 / r2) * Math.pow(10, t2 - t1)
  }
}

export const xmlHttpDownload = ({ url, title = (new Date()).getTime() }) => {
  var xhr = new XMLHttpRequest()
  xhr.open('GET', url, true)
  xhr.responseType = 'blob'
  xhr.onload = function(e) {
    if (this.status == 200) {
      var blob = new Blob([this.response], {type: 'application/pdf'});
      var a = document.createElement('a')
      a.href = window.URL.createObjectURL(blob)
      a.download = title
      document.body.appendChild(a)
      a.click()
    }
  }
  xhr.send()
}

export const download = (options) => {
  const uid = (new Date()).getTime()
  const {
    url,
    blob,
    title = uid,
    target,
    rel
  } = options
  const a = document.createElement('a')
  a.style.display = 'none'
  a.download = title
  if (target) {
    a.target = target
  }
  if (rel) {
    a.rel = rel
  }
  if (blob) {
    let newBlob = new Blob([blob])
    const blobUrl = window.URL.createObjectURL(newBlob)
    a.href = blobUrl
    a.click()
  } else if (url) {
    a.href = url
    a.click()
  }
}

export const delInArr = (arr, index) => {
  const newArr = deepCopy(arr)
  newArr.splice(index, 1)
  return newArr
}

export const addToArr = (arr, index, item) => {
  const newArr = deepCopy(arr)
  newArr.splice(index, 0, item)
  return newArr
}

export const hasOwnProperty = (obj, key) => {
  if (obj && obj.hasOwnProperty(key)) {
    return true
  }
  return false
}

// 嵌套对象判断
export const isContainObj = (obj, needle, keyInobj) => {
  for (let i in obj) {
    if (obj[i][keyInobj] === needle) return true
  }
  return false
}

export const sortByKey = (arr, key, type = 'asc') => {
  let newArr = deepCopy(arr)
  if (type === 'asc') {
    newArr.sort((a, b) => {
      if (a[key] < b[key]) {
        return -1
      } else if (a[key] > b[key]) {
        return 1
      } else {
        return 0
      }
    })
  } else {
    newArr.sort((a, b) => {
      if (a[key] > b[key]) {
        return -1
      } else if (a[key] < b[key]) {
        return 1
      } else {
        return 0
      }
    })
  }
  return newArr
}

export const isObject = (val) => {
  return val !== null && typeof val === 'object' && Array.isArray(val) === false
}

//isLength：检查 value 是否为有效的类数组长度
export const isLength = (value) => {
  return typeof value === 'number' && value > -1 && value % 1 === 0 && value <= Number.MAX_SAFE_INTEGER
}

//isFunction：检查 value 是不是函数
export const isFunction = (value) => {
  return Object.prototype.toString.call(value) === '[object Function]'
}

//isArrayLike：检查 value 是否是类数组
export const isArrayLike = (value) => {
  return value != null && isLength(value.length) && !isFunction(value)
}

//isPlainObject：判断数据是不是Object类型的数据
export const isPlainObject = (obj) => {
  return Object.prototype.toString.call(obj) === '[object Object]'
}
export const setMonths = (money) => {
    let num = money+''
    console.log(num)
    let arr = num.split('.')
    if (arr[1]) {
     return  Number(arr[1]) < 10 ? Number(arr[1])+'0' : money
    } else {
      return money+'.00'
    }
}
// isEmpty：检查 value 是否为空
export const isEmpty = (value) => {
  if (value === null) {
    return true
  }
  if (value === undefined) {
    return true
  }
  if (isArrayLike(value)) {
    return !value.length
  } else if (isPlainObject(value)) {
    for (let key in value) {
      if (hasOwnProperty.call(value, key)) {
        return false
      }
    }
  }
  return false
}

//处理数组数量
export const dealArrGroup = (array, subGroupLength) => {
  var index = 0
  var newArray = []
  while (index < array.length) {
    newArray.push(array.slice(index, index += subGroupLength))
  }
  return newArray
}

export const ConvertNumber = (number, count = 2, isSavePoint = false) => {
  if (number === undefined || number === null || number === '') {
    return number
  }
  if (typeof number == 'string' && number.includes(',')) {
    return number
  }
  number = +number
  if (!isNaN(number)) {
    if (`${number}`.includes('.')) {
      let _inter = `${number}`.split('.')[0]
      let _point = '0.' + `${number}`.split('.')[1]
      let numPoint = Number(_point)
      let strPoint = ''
      if (!isSavePoint) {
        strPoint = numPoint.toFixed(count)
        strPoint = '.' + `${strPoint}`.split('.')[1]
        number = _inter.replace(/\B(?=(\d{3})+\b)/g, ',') + strPoint
      } else {
        number = _inter.replace(/\B(?=(\d{3})+\b)/g, ',') + numPoint
      }
    } else {
      // number = number.toFixed(count).replace(/\d(?=(?:\d{3})+\b)/g, '$&,')
      // number = (number.toFixed(count) + '').replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')
      number = number.toFixed(count).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
    }
  }
  return number
}
export const NumFormat = (value) => {
  if (!value) return '0.00'
  value = value.toFixed(2)
  var intPart = Math.trunc(value) // 获取整数部分
  var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') // 将整数部分逢三一断
  var floatPart = '.00' // 预定义小数部分
  var value2Array = value.split('.')
  // =2表示数据有小数位
  if (value2Array.length === 2) {
    floatPart = value2Array[1].toString() // 拿到小数部分
    if (floatPart.length === 1) {
      return intPartFormat + '.' + floatPart + '0'
    } else {
      return intPartFormat + '.' + floatPart
    }
  } else {
    return intPartFormat + floatPart
  }
}
export const AutoFillNumber = (number, count = 2) => {
  if (!isEmpty(number))
	{
    var str=number.toString()
    if (str = '...') {

    } else {
      //是否补零
      var index
      if(str.indexOf(".") == -1){
        index = count
        str += '.'
      }else{
        index=count-((str.length-1)-str.indexOf("."))
      }
      for(var i=0; i<index; i++){
        str+='0'
      }
      return str
    }
	}
	return number
}
export const ParseNumber = (data, parsenumber = true) => {
    if (typeof data == 'string'  ) {
      if(data.includes(',')){
        data = `${data}`.replace(/\,/g, '');
      }
     if(data.includes('%')){
      data = `${data}`.replace(/\%/g, '');
      data/=100;
     }
    }
    if (parsenumber &&data&& typeof data != 'number') {
      data = +data;
    }
    return data;
}
export const ConvertPercent = (number, count = 2, removal = true) => {
  if (number === undefined) {
    return number
  }
  if (typeof number != 'string') {
    number = `${number}`
  }
  if (number.includes('%')) {
    return number
  }
  if (number.includes(',')) {
    let aValues = number.split(',')
    aValues = aValues.map((item) => {
      if (!isNaN(item)) {
        return `${(item * 100).toFixed(count)}%`
      }
    })
    if (removal) {
      aValues = [...new Set(aValues)]
    }
    number = aValues.join(',')
  } else {
    number = `${(number * 100).toFixed(count)}%`
  }
  return number
}
/*导入excel*/
export const readWorkbookFromLocalFile = (file, callback) => {
  var reader = new FileReader()
  reader.onload = function (e) {
    var data = e.target.result
    var workbook = XLSX.read(data, { type: 'binary' })
    if (callback) callback(workbook)
  }
  reader.readAsBinaryString(file)
}
/*获取表格*/
export const readWorkbook = (workbook) => {
  var sheetNames = workbook.SheetNames // 工作表名称集合
  var worksheet = workbook.Sheets[sheetNames[0]] // 这里只读取第一张sheet
  var csv = XLSX.utils.sheet_to_json(worksheet)
  return csv
  // document.getElementById('result').innerHTML = csv2table(csv);
}

export function removeByValue(arr, attr, value) { //数组，属性，属性值
  let newarr = deepCopy(arr)
  let index = 0
  for (let i in newarr) {
    if (newarr[i][attr] === value) {
      index = i
      break
    }
  }
  return newarr.splice(index, 1)
}

/*
str:要绘制的字符串
canvas:canvas对象
initX:绘制字符串起始x坐标
initY:绘制字符串起始y坐标
lineHeight:字行高
*/
export function canvasTextAutoLine (str, canvas, initX, initY, lineHeight, textWidth) {
  var ctx = canvas.getContext("2d")
  var lineWidth = 0
  // var canvasWidth = canvas.width
  var lastSubStrIndex = 0
  str = str.toString()
  for (let i = 0; i < str.length; i++) {
    lineWidth += ctx.measureText(str[i]).width
    let isNextLine = str.substr(i, 1) === '\n'
    // let isLastLine = str.substr(i - 1,2) === '\\n'
    if (lineWidth > textWidth || isNextLine) {
      ctx.fillText(str.substring(lastSubStrIndex, i), initX, initY)
      initY += lineHeight
      lineWidth = 0
      lastSubStrIndex = i
      if (isNextLine) {
        lastSubStrIndex = i + 1
      }
    }
    if (i === str.length - 1) {
      ctx.fillText(str.substring(lastSubStrIndex, i + 1), initX, initY)
    }
  }
}

/**
 * 截取字符串(通过substring实现并支持中英文混合)
 * @param str
 * @param n 需要截取的长度
 * @returns {*}
 */
export const subMixStr = (str, n) => {
  var r=/[^\x00-\xff]/g
  if(!str){
    return str
  }
  if (str && str.replace(r,"**").length<=n) {
    return str
  }
  var m=Math.floor(n/2)
  for (var i=m; i<str.length; i++) {
      if(str.substr(0,i).replace(r,"**").length>=n){
          return str.substr(0,i)
      }
  }
  return str
}
/*
* 按照固定长度拆分字符串
*/
export const subStrToArray = (str, n = 4) => {
  var strArr = []
  for (var i = 0, l = str.length; i < l/n; i++) {
    var a = str.slice(n*i, n*(i+1))
    strArr.push(a)
  }
  return strArr
}

export const getMixLength = (str = '') => {
  var realLength = 0, len = str.length, charCode = -1
  for (var i = 0; i < len; i++) {
    charCode = str.charCodeAt(i)
    if (charCode >= 0 && charCode <= 128)
       realLength += 1
    else
       realLength += 2
  }
  return realLength
}

export const  getDayTime =  function () {
  let now = new Date();
  let year = now.getFullYear()
  let month = now.getMonth() + 1
  let day = now.getDate()
  let clock = year + '-'
    if (month < 10)
      clock += '0'
    clock += month + '-'
    if (day < 10)
      clock += '0'
    clock += day + ' '
  return clock
}


export const renderTextWithConfig = (text, config) => (!text && text!==0) ? null : ((config || []).find(t => t.value === text) ? (config || []).find(t => t.value === text).title : text)

export const getConfigWithText = (text, config) => (!text && text!==0) ? null : ((config || []).filter(t => t.value === text).length ? (config || []).filter(t => t.value === text)[0] : null)

export const isTaxNo = (str) => {
  return str.match(/(^[0-9A-Za-z]{9}$)|(^[0-9A-Za-z]{15}$)|(^[0-9A-Za-z]{17}$)|(^[0-9A-Za-z]{18}$)|(^[0-9A-Za-z]{19}$)|(^[0-9A-Za-z]{20}$)/)
}

export const isMobileNo = (str) => {
  return str.match(/^((13[0-9])|(14[0-9])|(15[0-9])|(16[0-9])|(17[0-9])|(18[0-9])|(19[0-9]))\d{8}$/)
}

export const isEmail = (str) => {
  return str.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
}

/**
 *
 * @param treeData 树形数据
 * @returns 返回一个扁平化的数组
 */
 export const arrFlattening = (treeData, key = 'children') => {
  let res = []
  const a = (treeData) => {
    treeData.forEach(el => {
      res.push(el)
      // eslint-disable-next-line no-unused-expressions
      el[key] && el[key].length > 0 ? a(el[key]) : ""
    })
  }
  a(treeData)
  return res
}

export const stringGbkLength = (str) => {
  let realLength = 0
  var len = str.length;
  var charCode = -1;
  for(var i = 0; i < len; i++){
    charCode = str.charCodeAt(i);
    if (charCode >= 0 && charCode <= 128) {
      realLength += 1;
    } else {
      realLength += 2;
    }
  }
  return realLength;
}

export const cutImageBase64 = (file,id,wid,quality,callback=()=>{}) => {
  console.log(file)
  var URL = window.URL || window.webkitURL
  var blob = URL.createObjectURL(file)
  var base64
  var img = new Image()
  img.src = blob
  img.onload = function() {
    var that = this
    //生成比例
    var w = that.width,
    h = that.height,
    scale = w / h
    w = wid || w
    h = w / scale
    //生成canvas
    var canvas = document.createElement('canvas')
    var ctx = canvas.getContext('2d')
    canvas.setAttribute('width',w)
    canvas.setAttribute('height',h)
    ctx.drawImage(that, 0, 0, w, h)
    // 生成base64
    base64 = canvas.toDataURL('image/jpeg', quality || 0.8)
    callback(base64)
  }
}

const cryptoSecretKey = 'WOB7H5UY85U45KYC'
const cryptoSecretIv = 'CAMV2THJWK8X6AVG'
/**
 *
 * @param params 要加密的参数
 * @param noStringify 是否JSON.stringify, 传单个变量，会多加双引号
 * @returns
 */
export const aesDoEncrypt = (params, noStringify) => {
  var key = CryptoJS.enc.Utf8.parse(cryptoSecretKey)
  var iv = CryptoJS.enc.Utf8.parse(cryptoSecretIv)
  let result = CryptoJS.AES.encrypt(noStringify ? params : JSON.stringify(params), key, {
    iv: iv,
  })
  let resultData = result.ciphertext.toString()
  return resultData
}

export const aesDoDecrypt = (params) => {
  var key = CryptoJS.enc.Utf8.parse(cryptoSecretKey)
  var iv = CryptoJS.enc.Utf8.parse(cryptoSecretIv)
  let returnData = CryptoJS.AES.decrypt(params, key, {
    iv,
    format: format,
  })
  return JSON.parse(returnData.toString(CryptoJS.enc.Utf8))
}

export const checkResource = (code) => {
  if (!window.resourceList) {
    return false
  }
  return window.resourceList.checkAuth({
    type: 'resourceCode',
    resourceCode: code
  })
}

export const resourceTips = ({ type = 5 }) => {
  let text = '当前企业权限不足，请升级会员或联系客服解决。'
  switch (type) {
    case 0:
      text = '当前剩余数量不足，请升级会员或联系客服解决。'
      break
    case 1:
      text = '当前账号已过期，请升级会员或联系客服解决。'
      break
    case 2:
      text = '当前企业权限不足，请升级会员或联系客服解决。'
      break
    case 3:
      text = '当前剩余次数不足，请升级会员或联系客服解决。'
      break
    case 4:
      text = '当前企业权限不足，请升级会员或联系客服解决。'
      break
    case 5:
      text = '当前企业权限不足，请升级会员或联系客服解决。'
      break
    default:
      return null
  }
  Notify({ type: 'danger', message: text })
}

export const getMd5String = (code = '') => {
  return md5(code).toString()
}

export class onCheckTaxRate {
  /**
   * nature 企业性质 1 一般纳税人 2 小规模纳税人
   * invoiceType 发票类型
   * */
  check = ({ nature, details = [], invoiceType }) => {
    return new Promise((resolve, reject) => {
      if (nature === 2) { // 小规模纳税人需要判断 明细行里是否有 税率大于0.05的 有就报错
        let isTaxRateOk = true
        let rateList = []
        details.forEach(v => {
          if (v.taxRate > 0.05 || (Number(v.taxRate) === 0 && Number(v.taxPre) === 1)) {
            isTaxRateOk = false
          }
          if (invoiceType) { // 当小规模开局普票/电普时，选了1%以外的，需要提示
            if (!isEmpty(v.taxRate) && !rateList.includes(v.taxRate) && v.taxRate !== 0.01 && invoiceType !== 1 && invoiceType !== 4) { // 普票需提示
              rateList.push(v.taxRate)
            }
          }
        })
        let warningText = []
        if (!isTaxRateOk) {
          warningText.push('您的公司企业性质为小规模纳税人，只能开具5%、3%、1.5%、1%、免税税率的发票')
        }
        if (rateList.length) {
          warningText.push('自2023年1月1日至2023年12月31日，小规模纳税人适用3％征收率的应税销售收入，减按1％征收率征收增值税，请重新选择适用税率')
        }
        resolve(warningText)
      } else {
        resolve([])
      }
    })
  }

  /**
   * 检查即征即退的明细，即征即退的不能跟其他的商品一起开具，有混在一起的，就报错
   * details 开票明细项
   */
  checkImmediateLevyRefund = ({ details = []}) => {
    return new Promise((resolve, reject) => {
      let immediateLevyRefundCodeList = []
      let withEmptyCode = false
      details.forEach(v => {
        if (!isEmpty(v.immediateLevyRefundCode) && !immediateLevyRefundCodeList.includes(v.immediateLevyRefundCode)) { // 把即征即退的明细拿出来，数组有的话就代表有即征即退的明细
          immediateLevyRefundCodeList.push(v.immediateLevyRefundCode)
        }
        if (isEmpty(v.immediateLevyRefundCode)) { // 判断是否有不是即征即退的明细, 有的话就打标记
          withEmptyCode = true
        }
      })
      if (immediateLevyRefundCodeList.length && !withEmptyCode) { // 全部都是即征即退
        resolve([])
        return
      }
      if (immediateLevyRefundCodeList.length === 0) { // 没有即征即退
        resolve([])
        return
      }
      resolve(['校验未通过，即征即退类型商品无法与其他类型商品混开'])
    })
  }
}

export const getDingCode = () => {
  return new Promise((resolve, reject) => {
    if (dd.env.platform !== 'notInDingTalk') {
      let corpId = localStorage.get('corpId')
      dd.ready(function () {
        dd.runtime.permission.requestAuthCode({
          corpId: corpId, // 企业id
          onSuccess: function (info) {
            resolve(info.code)
          },
          onFail: function () {
            resolve()
          }
        })
      })
    } else {
      console.error('不在钉钉环境')
      resolve()
    }
  })
}

/**
 * @param {*} a 发票1
 * @param {*} b 发票2
 */
export const isSameByInvoiceCode = (a, b) => {
  if (!a || !b) {
    return false
  }
  if(((a.invoiceCode || '') + (a.invoiceNo || '')) === ((b.invoiceCode || '') + (b.invoiceNo || ''))) {
    return true
  } else {
    return false
  }
}

export const renderDTOpenData = async () => {
  const registerFrom = localStorage.get('registerFrom')
  if (registerFrom === '11') {
    try {
      // window.WWOpenData.bindAll(document.querySelectorAll('ww-open-data'))
      document.querySelectorAll('ww-open-data').forEach(v => {
        WWOpenData.bind(v)
      })
    } catch (error) {
      console.log(`error`, error)
    }
  }
}

/**
 * @description 判断是否是minio上传逻辑， 经过跟Justin沟通，该字段为唯一判断标识，有就是minio，没有就是oss
 */
 export const isMinioUpload = () => {
  const minioAdressUrl = platformConfig.getMinioAdressUrl()
  console.log(minioAdressUrl, 'minioAdressUrl')
  if (minioAdressUrl) {
    return true
  }
  return false
}

/**
 * @description 判断是否是普票
 */
export const isUniversalTicket = (type) => {
  return [2, 3, 7].includes(Number(type || 0) || 0)
}

/**
 * @description 判断是否是专票
 */
export const isSpecialTicket = (type) => {
  return [1, 4, 8].includes(Number(type || 0) || 0)
}
/**
 * @description 判断是否是电票
 */
export const isElectricTicket = (type) => {
  return [3, 4, 7, 8].includes(Number(type || 0) || 0)
}

/**
 * @description 判断是否是数电
 */
export const isAllElectric = (type) => {
  return [7, 8].includes(Number(type || 0) || 0)
}

/**
 * @description 判断是否是慧穗云普惠版
 */
export const isH5Plus = () => {
  let config = localStorage.get('systemconf') || '{}'
  config = JSON.parse(config)
  if (config.isH5Plus) {
    return true
  }
  return false
}


/**
 * @description 设置浏览器缓存
 */

 export const setWebCache = (type, value) => {
  let config = {}
  if (localStorage.get('cacheList')) {
    config = aesDoDecrypt(localStorage.get('cacheList'))
  }
  config[type] = value
  localStorage.set('cacheList', aesDoEncrypt(config))
}

/**
 * @description 获取浏览器缓存
 */

export const getWebCache = (type) => {
  let config = {}
  if (localStorage.get('cacheList')) {
    config = aesDoDecrypt(localStorage.get('cacheList'))
  }
  return config[type] || null
}





export default {
  uuid,
  cookie,
  getQuery,
  getDayTime,
  formatDate,
  sessionStorage,
  localStorage,
  countProperties,
  find,
  isSameByInvoiceCode,
  getInvoiceType,
  isElectricTicket,
  deepCopy,
  isArr,
  scrollTo,
  memoize,
  throttle,
  debounce,
  convertBase64UrlToBlob,
  dataURLtoFile,
  isMobile,
  toMoney,
  digitUppercase,
  onCount,
  download,
  setMonths,
  delInArr,
  hasOwnProperty,
  isContainObj,
  sortByKey,
  isObject,
  isLength,
  isFunction,
  isArrayLike,
  isPlainObject,
  isEmpty,
  dealArrGroup,
  ConvertNumber,
  AutoFillNumber,
  ParseNumber,
  ConvertPercent,
  removeByValue,
  addToArr,
  canvasTextAutoLine,
  subMixStr,
  subStrToArray,
  renderTextWithConfig,
  getMixLength,
  isMobileNo,
  isEmail,
  NumFormat,
  isTaxNo,
  cutImageBase64,
  aesDoEncrypt,
  aesDoDecrypt,
  getThisMonth,
  compressFile,
  getDingCode
}
